import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { ThemeProvider } from 'next-themes'
import App from './App.tsx'
import './index.css'

createRoot(document.getElementById("root")!).render(
  <ThemeProvider attribute="data-theme" defaultTheme="system" enableSystem enableColorScheme disableTransitionOnChange>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </ThemeProvider>
);
